import React, { useState, useEffect } from 'react';
import { Typography, Button, Table, Form, DatePicker, Space, Tooltip, Modal, theme } from 'antd';
import { ClearOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import '../FIXExecutionOrderLogPage/fixLog.css';
import dayjs from 'dayjs';
import { objectToQueryString } from '../../util/Common';
import TradeProcessHistoryService from '../../services/TradeProcessHistoryService';
import MatchTradeList from './MatchTradeList';

const { Title } = Typography;
const { RangePicker } = DatePicker;

const TradeProcessHistory = () => {
  const location = useLocation();
  const [applicationList, setApplicationList] = useState([]);
  const navigate = useNavigate();
  const { showNotification } = useAuth();
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [open, setOpen] = useState(false);
  const [matchingProcessId, setMatchingProcessId] = useState();
  const [tradeWindow, setTradeWindow] = useState();
  const handleView =(matchingProcessId,tradeWindow) => {
    setOpen(true);
    setMatchingProcessId(matchingProcessId);
    setTradeWindow(tradeWindow)
  };


  const queryParams = new URLSearchParams(location.search);

  const startTimestamp = Number(queryParams.get('startDate')) || null;
  const endTimestamp = Number(queryParams.get('endDate')) || null;

  const startDate = startTimestamp ? dayjs(startTimestamp * 1000) : null;
  const endDate = endTimestamp ? dayjs(endTimestamp * 1000) : null;
  console.log(new Date(startDate).getDate())
  const startDateTime = new Date(startDate).getFullYear() * 10000 + (new Date(startDate).getMonth() + 1) * 100 + new Date(startDate).getDate();
  const endDateTime = new Date(endDate).getFullYear() * 10000 + (new Date(endDate).getMonth() + 1) * 100 + new Date(endDate).getDate();
  console.log(new Date(startDate), new Date(endDate))
  const page = Number(queryParams.get('page')) || 1;
  const size = Number(queryParams.get('size')) || 10;

  const loadData = async () => {
    const payload = {
      startTradeWindow: startDate!==null ? startDateTime.toString() : null,
      endTradeWindow: endDate!==null ? endDateTime.toString() : null,
      page: page,
      size: size,
    };
    setLoading(true);
    const result = await TradeProcessHistoryService.getTradeProcessHistory(payload);
    setLoading(false);
    if (result.success) {
      setApplicationList(result.data);
      setTotalCount(result.total);
    } else {
      showNotification('error', result.message);
    }
  };

  useEffect(() => {
    loadData(); // Initial load with null startDate and endDate
  }, [location.search]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const formLayout = windowWidth <= 1024 ? 'vertical' : 'inline';

  const handleRefresh = () => {
    navigate('/trading/trade-process-history');
    form.setFieldsValue({
      selectDates: [null, null],
      messageType: null,
    });
  };

  const onFinish = async formValues => {
    const startDate =
      formValues.selectDates && formValues.selectDates[0]
        ? new Date(formValues.selectDates[0])
        : null;
    const endDate =
      formValues.selectDates && formValues.selectDates[1]
        ? new Date(formValues.selectDates[1])
        : null;

    //loadData(unixStartDate, unixEndDate);
    let payload = {
      startDate: startDate !== null ? Math.floor(startDate.getTime() / 1000) : null,
      endDate: endDate !== null ? Math.floor(endDate.getTime() / 1000) : null,
      page: 1,
      size: 10,
    };

    const queryString = objectToQueryString(payload);
    navigate(`/trading/trade-process-history?` + queryString);
  };

  // Table columns
  const columns = [
    {
      title: 'Trade Window',
      dataIndex: 'tradeWindow',
      key: 'tradeWindow',
    },
    {
      title: 'Transfer Window',
      dataIndex: 'transferWindow',
      key: 'transferWindow',
    },
    {
      title: 'Settlement Window',
      dataIndex: 'settlementWindow',
      key: 'settlementWindow',
    },
    {
      title: 'Matching Status',
      dataIndex: 'matchingStatus',
      key: 'matchingStatus',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space direction="horizontal" size={'middle'}>
          <Button type={'primary'} size="small" onClick={() => handleView(record.matchingProcessId, record.tradeWindow)}>
            View
          </Button>
        </Space>
      ),
    },
  ];

  const {
    token: { colorPrimary },
  } = theme.useToken();

  return (
    <>
    {open && (
        <Modal
          title={
            <Title level={4} style={{ marginTop: 0, marginBottom: '1.5rem', color: colorPrimary }}>
              Trade Matching Record List
            </Title>
          }
          open={open}
          centered
          width={1000}
          onCancel={() => setOpen(false)}
          footer={[]}
        >
          <MatchTradeList matchingProcessId={matchingProcessId} tradeWindow={tradeWindow}/>
        </Modal>
      )}
      <Title level={4} style={{ marginTop: 0 }}>
        Trade Process History
      </Title>
      <Form
        onFinish={onFinish}
        form={form}
        className="right-aligned-form"
        layout={formLayout}
        initialValues={{
          selectDates: [startDate, endDate],
        }}
      >
        <Form.Item label="Select Dates" name={'selectDates'}>
          <RangePicker style={{ width: '100%' }} />
        </Form.Item>
        <Space style={{ float: 'right' }}>
          <Tooltip title="Clear fields">
            <Button
              type="default"
              size={'middle'}
              icon={<ClearOutlined />}
              onClick={handleRefresh}
            ></Button>
          </Tooltip>
          <Button type="primary" size="middle" htmlType="submit" key={'submit'}>
            Search
          </Button>
        </Space>
      </Form>
      <Table
        loading={loading}
        style={{ paddingTop: '1rem' }}
        columns={columns}
        dataSource={applicationList.map(log => ({ ...log, key: log.fixExecutionOrderReportId }))}
        size={'large'}
        bordered
        scroll={{
          x: 'max-content',
        }}
        pagination={{
          current: page,
          pageSize: size,
          total: totalCount,
        }}
        onChange={(pagination, filters, sorter) => {
          const formValues = {
            startDate: startTimestamp,
            endDate: endTimestamp,
            page: pagination.current,
            size: pagination.pageSize,
          };

          const queryString = objectToQueryString(formValues);
          navigate(`/trading/trade-process-history?` + queryString);
        }}
      />
    </>
  );
};

export default TradeProcessHistory;
